import React, { useEffect } from "react";

const IframeWrapper = React.memo(
  ({ iframeSrc, iframeRef, iframeLoaded, onIframeMount, id, title }) => {
    useEffect(() => {
      if (onIframeMount) {
        onIframeMount();
      }
    }, []);

    return (
      <iframe
        src={iframeSrc}
        width="100%"
        height="100%"
        ref={iframeRef}
        onLoad={iframeLoaded}
        frameBorder="0"
        allow="camera; microphone;fullscreen;"
        tabIndex={-1}
        id={id}
        title={title}
      ></iframe>
    );
  }
);

IframeWrapper.displayName = "IframeWrapper";
export default IframeWrapper;
